import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FlagTriangleRight = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-flag-triangle-right-icon lucide-flag-triangle-right'
      >
        <path d='M6 22V2.8a.8.8 0 0 1 1.17-.71l11.38 5.69a.8.8 0 0 1 0 1.44L6 15.5' />
      </svg>
    </SvgIcon>
  );
};

export default FlagTriangleRight;
